/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { Caption } from './Text';

import { Icons } from '../../bphComponents/bundle';
import COLORS from '../styles/Colors';

const CheckboxInput = (props) => (
  <div className="cmp-input-checkbox">
    <input
      id={props.name}
      type="checkbox"
      name={props.name}
      value={props.value}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      onChange={props.onChange}
      checked={props.checked}
    />
    <label htmlFor={props.name} className={props.checked ? 'profile-background-color profile-border-color' : null}>
      {props.checked ? <div style={{ marginTop: '-1px' }}><Icons.IconCheckmark.Small color={COLORS.gsLightest} /></div> : null}
    </label>
    <label htmlFor={props.name}>
      <Caption color={props.color || (props.checked ? 'profile' : 'neutral')}>
        {props.label}
      </Caption>
    </label>
  </div>
);
CheckboxInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.any,
  value: PropTypes.any.isRequired,
  checked: PropTypes.bool,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  color: PropTypes.string,
};

const CheckboxGroup = (props) => (
  <div className="cmp-input-checkbox-group">
    {props.children}
  </div>
);
CheckboxGroup.propTypes = {
  children: PropTypes.any,
};

export {
  CheckboxInput,
  CheckboxGroup,
};
